import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/material/styles";

const ItemContainer = styled(Grid)(({theme}) => ({
  columnGap: '0.57em',
  padding: '1.43em',
  alignItems: 'center',
  width: '100%',
  '&:not(:last-child)': {
    borderBottom: `0.07rem solid ${theme.palette.grey[200]}`,
  },
}));

interface PaymentMethodListCardProps {
  children?: React.ReactNode;
}

const PaymentMethodListCard = (props: PaymentMethodListCardProps) => {
  const {children} = props;

  return (
    <ItemContainer item container alignContent={'center'} justifyContent={'space-between'}>
      {children}
    </ItemContainer>
  );
};

export default PaymentMethodListCard;
